import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'bb-beneficiary-catalog',
  templateUrl: 'beneficiary-catalog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BeneficiaryCatalogComponent {
  /**
   * Contact item
   */
  @Input()
  set catalog(item: any & { accountName?: string }) {
    this._catalog = item;
  }
  get catalog() {
    return this._catalog;
  }

  @Input()
  displayBankName = false;

  private _catalog!: any & { accountName?: string };

  accountNumber?: string;
}
